import React from 'react';
import {PaymentFreeMonthDialog} from './payment-free-month/PaymentFreeMonthDialog';
import {FlexOfferDialog} from './flex/FlexOfferDialog';
import {DemoDialog} from './DemoDialog';
import {PPIAnytimeDialog} from './ppi-anytime/PPIAnytimeDialog';
import {HTMLDialog} from 'components/HTMLDialog/HTMLDialog';
import {ActivateCardDialog} from './activate-card/ActivateCardDialog';
import {PostponeOfferDialog} from './postpone/PostponeOfferDialog';
import {PreCollectionDialog} from './PreCollectionDialog/PreCollectionDialog';
import {InvoiceProcessDialog} from './invoice-process/InvoiceProcessDialog';
import {FeedbackDialog} from './feedback/FeedbackDialog';
import {OfferDialog} from './offers/OfferDialog';
import {UpdateContactInformationDialog} from './update-contact-information/UpdateContactInformationDialog';
import {VerifyContactDialog} from './verify-contact/VerifyContactDialog';
import {SavingsAccountsCloseDialog} from '../../features/deposit/close/SavingsAccountsCloseDialog';
import {SavingsAccountWithdrawalDialog} from '../../features/deposit/withdrawal/SavingsAccountWithdrawalDialog';
import {DigitalInvoiceNotificationDialog} from './DigitalInvoiceNotificationDialog/DigitalInvoiceNotificationDialog';
import {DigitalInvoiceNotificationForceDialog} from './DigitalInvoiceNotificationDialog/DigitalInvoiceNotificationForceDialog';
import {TrustpilotReviewDialog} from './Trustpilot/TrustpilotReviewDialog';
import {DepositAccountDirectTransferDialog} from '../../features/deposit/directTransfer/DepositAccountDirectTransferDialog';
import {DepositAccountMonthlyDepositDialog} from '../../features/deposit/monthlyDeposit/DepositAccountMonthlyDepositDialog';
import {PopupDialog} from './generic-popup/PopupDialog';

export const AppDialogs: React.FC = () => {
  return (
    <>
      <DemoDialog />
      <FlexOfferDialog />
      <PostponeOfferDialog />
      <PaymentFreeMonthDialog />
      <PPIAnytimeDialog />
      <HTMLDialog />
      <ActivateCardDialog />
      <PreCollectionDialog />
      <InvoiceProcessDialog />
      <FeedbackDialog />
      <OfferDialog />
      <DigitalInvoiceNotificationDialog />
      <DigitalInvoiceNotificationForceDialog />
      <UpdateContactInformationDialog />
      <VerifyContactDialog />
      <SavingsAccountsCloseDialog />
      <SavingsAccountWithdrawalDialog />
      <TrustpilotReviewDialog />
      <DepositAccountDirectTransferDialog />
      <DepositAccountMonthlyDepositDialog />
      <PopupDialog />
    </>
  );
};
